import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';

import { Controller, useForm } from "react-hook-form";
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useOrderTrackingInfoDataQuery, useOrderUpdateTrackingMutation } from '../../../Redux/OrderSlice';
const OrderStatus = ({ orderStatusDetails, isCancelled }) => {

  const { id } = useParams()



  const { data: trackingData } = useOrderTrackingInfoDataQuery(id, { skip: !id })
  const [orderUpdateTrackingFn, { data: orderUpdateTrackingData, error: orderUpdateTrackingErr, isLoading: orderUpdateTrackingLoading, isSuccess: orderUpdateTrackingSuccess }] =
    useOrderUpdateTrackingMutation();


  useEffect(() => {
    if (!orderUpdateTrackingLoading) {
      if (orderUpdateTrackingSuccess) {
        const message = orderUpdateTrackingData?.message || "Product created successfully";
        toast.success(message);
        // reset()



      }
      if (orderUpdateTrackingErr) {
        if ('data' in orderUpdateTrackingErr) {
          const errorData = orderUpdateTrackingErr;
          toast.error(errorData.data.message);

        }
      }
    }
  }, [orderUpdateTrackingData, orderUpdateTrackingSuccess, orderUpdateTrackingErr, orderUpdateTrackingLoading]);


  const initialTracking = {
    trackingNumber: "",
    trackingURL: "",
    expectedOrderDeliveryDate: '',
    customExpectedOrderDeliveryDate: ''
  }

  const { control, handleSubmit, formState, watch, setValue } = useForm({
    defaultValues: initialTracking,
  })
  const onSubmit = (data) => {
    console.log(data)
    orderUpdateTrackingFn({ ...data, id })

  };

  useEffect(() => {
    if (trackingData?.response?.orders?.id) {
      Object.keys(initialTracking).forEach(it => {
        setValue(it, trackingData?.response?.orders[it], {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true
        })
      })
    }
  }, [trackingData])
  //   const yy=watch();
  const expectedOrderDeliveryDate = watch('expectedOrderDeliveryDate')


  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="card-header d-flex  align-items-center gap-3">
        {/* <h5 className="card-title flex-grow-1 mb-0">Tracking  Status : {orderStatusDetails}</h5> */}


        <Controller
          name="expectedOrderDeliveryDate"
          control={control}
          render={({ field }) => (

            <Form.Select
              {...field}
              name='expectedOrderDeliveryDate'
              aria-label="Default select example">
              <option >Choose days</option>
              <option value="1days-3days">1days-3days </option>
              <option value="3days-5days">3days-5days </option>
              <option value="5days-7days">5days-7days</option>
              <option value="custom days">custom days</option>

            </Form.Select>



          )}
        />
        {expectedOrderDeliveryDate === 'custom days' &&
          <Controller
            name="customExpectedOrderDeliveryDate"
            control={control}
            render={({ field }) => <Form.Control type="text" placeholder="Enter days"
              {...field} />}
          />}
        <Controller
          name="trackingURL"
          control={control}
          render={({ field }) => <Form.Control type="text" placeholder="trackingURL"
            {...field} />}
        />
        <Controller
          name="trackingNumber"
          control={control}
          render={({ field }) => <Form.Control type="text" placeholder="trackingNumber"
            {...field} />}
        />

        {/* <input type="submit" /> */}

        {/* <Select
            {...field}
            options={[
              { value: "chocolate", label: "Chocolate" },
              { value: "strawberry", label: "Strawberry" },
              { value: "vanilla", label: "Vanilla" },
            ]}
          /> */}

        <div className="flex-shrink-0">
          <Button
            type='submit'
            variant='soft-danger' size="sm" className={`btn btn-sm mt-2 mt-sm-0 ${isCancelled && "disabled"}`} onClick={() => {
              // OrderCancelFunc(DeleteID.id)
            }
            }><i className="mdi mdi-archive-remove-outline align-bottom me-1"></i> Tracking Update</Button>
        </div>
      </div>
    </form>
  )
}

export default OrderStatus